export default __webpack_public_path__ + "images/maya-ship.svg";